<template>
  <div class="editor-timeline" id="editor-timeline">
  </div>
</template>

<script>
  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'
  // pixi
  import EditorTimeline from '@/common/scripts/pixi/EditorTimeline.js'
  export default {
      components: {
      },
      props:['timeline_toolbar'],
      data () {
          return {
              app: {},
          }
      },
      mounted () {
          let platform = this.$route.query.platform
          let con = document.getElementById('editor-timeline');
          let timeline = new EditorTimeline(con);
          timeline.start(platform, TIMELINE, TIMELINE_NAME, process.env.TIMELIME_ASSETS_SWF + "assets/");
      }
  }
</script>

<style lang="stylus">
  .editor-timeline
    position: absolute
    top: 0
    right: 0
    left: 0
    height: 78px
</style>



// WEBPACK FOOTER //
// EditorTimeline.vue?02473729